export default "__VITE_ASSET__D7mAaKpf__"